import React from 'react';

type ChipProps = {
  label?: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>;

const Chip = React.forwardRef<HTMLSpanElement, ChipProps>((props, ref) => {
  const { label, className = '', icon, ...rest } = props;
  const classes = `chip${className ? ' ' + className : ''}`;

  return (
    <span
      ref={ref}
      className={classes}
      aria-hidden={label === undefined}
      {...rest}
    >
      {icon && (
        <span className='iconify' aria-hidden='true'>
          {icon}
        </span>
      )}
      {label !== undefined && <span className='label'>{label}</span>}
    </span>
  );
});

Chip.displayName = 'Chip';

export default Chip;
